export default function Contact() {
  const socialLinks = [
    { name: 'Instagram', icon: 'ri-instagram-line', url: 'https://instagram.com/theBigBudWolf' },
    { name: 'X (Twitter)', icon: 'ri-twitter-x-line', url: 'https://x.com/theBigBudWolf' },
    { name: 'YouTube - FreshNeverStale', icon: 'ri-youtube-line', url: 'https://www.youtube.com/@FreshNeverStale' },
    { name: 'YouTube - HigherEXcellence', icon: 'ri-youtube-line', url: 'https://www.youtube.com/@HigherEXcellence/videos' },
    { name: 'YouTube - theBigBudWolf', icon: 'ri-youtube-line', url: 'https://www.youtube.com/@theBigBudWolf/videos' },
    { name: 'Bandcamp', icon: 'ri-disc-line', url: 'https://freshneverstale.bandcamp.com/' },
  ];

  return (
    <section
      id="contact"
      className="relative bg-black border-t border-white/10 py-20 px-6 md:px-20"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-16">
          <div>
            <h2
              className="text-6xl md:text-7xl font-black text-white mb-10 tracking-tight"
              style={{ fontFamily: 'Impact, "Arial Black", sans-serif', fontWeight: 900 }}
            >
              HigherEX
            </h2>

            <p
              className="text-base leading-relaxed text-white/60 mb-12 max-w-md"
              style={{ fontWeight: 300, lineHeight: 1.7 }}
            >
              ELEVATE YOUR CONSCIOUSNESS THROUGH HIPHOP
            </p>

            <div className="flex gap-5">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  className="w-11 h-11 flex items-center justify-center border border-white/30 rounded-full hover:border-white/70 hover:scale-110 transition-all duration-300 cursor-pointer"
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-lg text-white`} />
                </a>
              ))}
            </div>
          </div>

          <div className="flex items-center justify-center">
            <div className="w-[320px] h-[320px]">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="block w-full h-full cursor-pointer"
              >
                <img
                  src="https://static.readdy.ai/image/46e04b8c96e08f93680e66fd759611e1/3ef4f91621af03ae45a0525bb504fdd8.png"
                  alt="HigherEX Alt Logo"
                  className="w-full h-full object-contain"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/8 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-xs tracking-[0.1rem] text-white/40">
            © 2026 All rights reserved. FreshNeverStale Productions. Hip-Hop Music - Hip Hop Culture - HipHop Spirit
          </div>
        </div>
      </div>
    </section>
  );
}
